import React from 'react'
import Chip from '@material-ui/core/Chip'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { FormattedNumber } from 'react-intl'
import { createStyles, withStyles, WithStyles, Theme } from '@material-ui/core/styles'
import T from 'components/FormattedMessage'
import { IBetOffer } from 'protos'

interface Props {
  betOffer: IBetOffer
}

const styles = (theme: Theme) => createStyles({
  root: {
    fontSize: 11,
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightMedium
  },
  title: {
    color: 'inherit',
    fontSize: 'inherit',
    fontWeight: 'inherit',
    marginRight: theme.spacing()
  },
  oddLink: {
    color: 'inherit',
    textDecoration: 'none'
  },
  odd: {
    color: 'inherit',
    height: 20,
    borderRadius: 2,
    marginLeft: 2,
    marginRight: 2,
    backgroundColor: theme.palette.common.white,
  },
  providerLogo: {
    marginLeft: theme.spacing(),
    maxHeight: 16
  }
})

type InjectedProps = Props & WithStyles<typeof styles>

const BetOffer: React.SFC<InjectedProps> = ({ betOffer, classes, ...props }) => {
  return (
    <Grid container {...props} className={classes.root} alignItems="center" justify="center">
      <Grid item>
        <Typography className={classes.title}>
          <T id="betting_advertisement" />
        </Typography>
      </Grid>
      <Grid item>
        <a href={betOffer.away!.url!} target="_blank" rel="noopener noreferrer" className={classes.oddLink}>
          <Chip
            clickable
            variant="outlined"
            className={classes.odd}
            label={<FormattedNumber minimumFractionDigits={2} value={Number(betOffer.home!.odd)} />}
          />
        </a>
      </Grid>
      <Grid item>
        <a href={betOffer.away!.url!} target="_blank" rel="noopener noreferrer" className={classes.oddLink}>
          <Chip
            clickable
            variant="outlined"
            className={classes.odd}
            label={<FormattedNumber minimumFractionDigits={2} value={Number(betOffer.draw!.odd)} />}
          />
        </a>
      </Grid >
      <Grid item>
        <a href={betOffer.away!.url!} target="_blank" rel="noopener noreferrer" className={classes.oddLink}>
          <Chip
            clickable
            variant="outlined"
            className={classes.odd}
            label={<FormattedNumber minimumFractionDigits={2} value={Number(betOffer.away!.odd)} />}
          />
        </a>
      </Grid>
      <Grid item>
        <img src={betOffer.providerLogo!} alt="" className={classes.providerLogo} />
      </Grid>
    </Grid >
  )
}

export default withStyles(styles)(BetOffer)
